module.exports = __webpack_public_path__ + "img/server.8040aa8f.svg";